import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { api, setAuth } from '../api.js';

export default function Login() {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const { token, username: user, role } = await api.login(username.trim(), password);
            setAuth(token, user, role);
            navigate('/');
        } catch (err) {
            if (err.status === 401) {
                setError('Benutzername oder Passwort falsch.');
            } else if (err.status === 429) {
                setError('Zu viele Fehlversuche. Bitte später erneut versuchen.');
            } else {
                setError('Login fehlgeschlagen.');
            }
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="login">
            <form className="login__card" onSubmit={handleSubmit}>
                <h1 className="login__title">LMS Admin</h1>
                {error && <div className="login__error">{error}</div>}
                <div className="field">
                    <label htmlFor="username">Benutzername</label>
                    <input
                        id="username"
                        type="text"
                        autoComplete="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </div>
                <div className="field">
                    <label htmlFor="password">Passwort</label>
                    <input
                        id="password"
                        type="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" className="btn btn--primary" disabled={loading} style={{ width: '100%' }}>
                    {loading ? 'Anmeldung läuft…' : 'Anmelden'}
                </button>
            </form>
        </div>
    );
}
